export default __webpack_public_path__ + "9db981db5212a8f7e17ab699f349fe14.svg";